<template>
  <div class="md-layout my-4" ref="taskManagementComment">
    <div class="md-layout-item md-size-100 md-layout">
      <div class="md-layout-item md-size-60 p-0 border border-gray-300">
        <md-field>
          <md-textarea
            :placeholder="$t('smi_sri.comment')"
            v-model="content"
          ></md-textarea>
        </md-field>
      </div>
      <div class="md-layout-item my-auto">
        <md-button
          class="md-success"
          @click="addComment"
          :disabled="!content"
          >{{ $t("task_management.post_comment") }}</md-button
        >
      </div>
    </div>
    <div
      id="listComment"
      class="md-layout-item md-size-100 m-4 md-layout max-h-[500px] overflow-y-auto"
      v-show="commentList.length"
    >
      <div
        class="md-layout-item md-size-100 flex items-start my-4 p-0"
        v-for="(item, index) in commentList"
        :key="index + 'comment'"
      >
        <img
          :src="item.avatar || '/img/avt_placeholder.jpg'"
          class="object-cover rounded-full w-[42px] h-[42px] mt-1"
        />
        <div class="text-left pl-4 flex flex-col w-full">
          <div>
            <label class="font-medium text-[#000]">{{ item.name }}</label>
            <label class="text-[#aaa] ml-4">{{
              item.created_at | formatDateTime(userTz)
            }}</label>
          </div>
          <p class="text-[#aaa] break-all">"{{ item.content }}"</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import moment from "moment";
import { mapGetters } from "vuex";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";

const clientLocale = localStorage.getItem("language");
const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY hh:mm a" : "DD-MM-YYYY hh:mm a";
export default {
  props: ["taskType", "taskId"],
  data() {
    return {
      content: "",
      commentList: [],
      pageNumber: 0,
      totalData: 0,
      apiPending: false
    };
  },
  created() {
    this.fetchComment();
  },
  filters: {
    formatDateTime(date, userTimeZone) {
      return convertTimeByTimezone(
        date,
        "Etc/UTC",
        userTimeZone ?? moment.tz.guess(),
        formatDateClient
      );
    }
  },
  mounted() {
    const listElm = this.$refs.taskManagementComment.querySelector(
      "#listComment"
    );
    listElm.addEventListener("scroll", e => {
      if (
        listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight &&
        !this.apiPending
      ) {
        this.fetchComment();
      }
    });
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    addComment() {
      let param = {
        content: this.content
      };
      if (this.taskType === "main-task") {
        param.main_task_id = this.taskId;
      } else {
        param.sub_task_id = this.taskId;
      }
      this.$axios
        .post(`${service_names.school}/task-comment`, param)
        .then(() => {
          Message.success(this.$t("task_management.post_comment_success"));
          this.content = "";
          this.refreshComment();
        });
    },
    refreshComment() {
      this.pageNumber = 0;
      this.commentList = [];
      this.totalData = 0;
      this.fetchComment();
    },
    fetchComment() {
      this.pageNumber++;
      this.apiPending = true;
      if (
        this.commentList.length &&
        this.commentList.length >= this.totalData
      ) {
        return;
      }
      let param = {
        page: this.pageNumber
      };
      if (this.taskType === "main-task") {
        param.main_task_id = this.taskId;
      } else {
        param.sub_task_id = this.taskId;
      }
      this.$axios
        .get(`${service_names.school}/task-comment`, param)
        .then(res => {
          this.totalData = res.data.total;
          let resultList = res.data.data.map(item => {
            item.name = item.user?.user_no_sql?.full_name;
            return item;
          });
          this.commentList = [...this.commentList, ...resultList];
          this.apiPending = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
  appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #9a9a9a;
  border-radius: 25px;
}
</style>
